import React, {Component} from 'react';
import {Breadcrumb, Button, Header, Icon, Image, Label, List, Popup} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import localDB from "../../data/localDB";
import DynamicTable from "../../components/extras/DynamicTable";
import {FormattedNumber} from "react-intl";
import DeliveryState from "../../components/sale/DeliveryState";

class OrdenNumber extends Component{
    render(){
        return <span>
            N° {this.props.sale.billing_number}
        </span>
    }
}

class Contact extends Component{

    render(){
        if(this.props.sale.client){
            return <List divided>
                <List.Item>
                    <List.Content>
                        <List.Header as='h3'>{this.props.sale.client.full_name}</List.Header>
                    </List.Content>
                </List.Item>
                <List.Item>
                    <List.Icon name='marker'/>
                    <List.Content>{this.props.sale.client.address ? this.props.sale.client.address:'---'}</List.Content>
                </List.Item>
                <List.Item>
                    <List.Icon name='phone'/>
                    <List.Content>{this.props.sale.client.phone ? this.props.sale.client.phone:'---'}</List.Content>
                </List.Item>
            </List>
        }else{
            return <Label color='orange'>Sin Asignar</Label>
        }

    }
}

class Total extends Component {
    render() {
        return <React.Fragment>
            <Header as='h3' textAlign='center' style={{margin:'0px'}}>
                Total Venta: $<FormattedNumber
                value={this.props.sale.total.total_sale}
                currency="USD"
                maximumFractionDigits={0}
                minimumFractionDigits={0}
            />
            </Header>
            {
                this.props.sale.total.balance !== 0 ? <Header as='h3' textAlign='center' style={{margin:'0px'}} color='orange'>
                    Saldo: $<FormattedNumber
                    value={this.props.sale.total.balance}
                    currency="USD"
                    maximumFractionDigits={0}
                    minimumFractionDigits={0}
                />
                </Header>:null
            }
        </React.Fragment>
    }
}

class State extends Component {
    render() {
        return <DeliveryState state={this.props.sale.delivery_state} id={this.props.sale.id} all_options={false}/>
    }
}

class SaleItems extends React.Component {
    render() {
        return <List divided relaxed>
            { this.props.sale.items.length >0 ?
                this.props.sale.items.map(function (item) {
                    return (
                        <List.Item key={item.id}>
                            <Image avatar>
                                <Label circular color='orange'>{item.quantity}</Label>
                            </Image>
                            <List.Content>
                                <List.Header as='h3'>{item.product.name}</List.Header>
                                <List.Description>{item.observation}</List.Description>
                            </List.Content>
                        </List.Item>
                    )
                }):<List.Item>
                    <List.Content>
                        <List.Description>
                            <Label style={{width:'100%'}}>
                                <Icon name='alarm' /> No se han agregado productos
                            </Label>
                        </List.Description>
                    </List.Content>
                </List.Item>
            }
        </List>
    }
}

class Deliveries extends Component {
    constructor(props) {
        super(props);

        let more_actions = [
            this.buttonObservations
        ]

        this.state = {
            table: {
                headers: ['Orden N°', 'Contácto', 'Pedido', 'Total', 'Estado'],
                name: 'Mis Deliveries',
                title: 'Mis Deliveries',
                has_actions: false,
                other_actions: false,
                edit: false,
                can_add: false,
                pagination: true,
                delete: false,
                url: 'my-deliveries',
                values: ['delivery_man', 'channel', 'sale', 'observations', 'start_date'],
                component_fields:[{
                    delivery_man: OrdenNumber,
                    channel: Contact,
                    sale: SaleItems,
                    observations: Total,
                    start_date: State
                }],
                id: 'table_deliveries',
                more_actions: more_actions,
            },
        };
    }

    buttonObservations = (data) => {
        return <Popup
            trigger={<Button icon='sticky note outline' onClick={()=>this.props.productPricesDialog({id: data.id, name: data.name, is_open:true})}/>}
            content='Observaciones'
            position='top left'
            key={data.id}
        />;
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.product_select && nextProps.product_select.hasOwnProperty('id')){
            localDB.addOrUpdateDB('products', {id:nextProps.product_select.id, name:nextProps.product_select.name});
            this.props.dynamicTableAddOrUpdate(nextProps.product_select);
        }
    }

    buttonPrices = (data) => {
        return !localDB.get('plan_access')['access_exclude'].includes('warehouse') ? <Popup
            trigger={<Button icon='money bill alternate' onClick={()=>this.props.productPricesDialog({id: data.id, name: data.name, is_open:true})}/>}
            content='Precios'
            position='top left'
            key={data.id}
        />:null;
    }

    showRecipes = (data) => {
        this.props.productRecipesDialog({id: data.id, name: data.name, is_open:true});
    }

    render() {

        return (
            <div>
                <Helmet>
                    <title>Domicilios - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Domicilios</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
            </div>
        );
    }
}

export default Deliveries;



// WEBPACK FOOTER //
// ./src/containers/deliveries/Deliveries.js